// removed by extract-text-webpack-plugin
module.exports = {"Container":"Slider__Container__3ffFj","Slider":"Slider__Slider__1uKVZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Slider/Slider.css
// module id = 152
// module chunks = 0